"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("String.Chars.Time", "__impl__", 1, "public", [{params: (context) => [Type.atom("for")], guards: [], body: (context) => {
return Type.atom("Elixir.Time");
}}, {params: (context) => [Type.atom("protocol")], guards: [], body: (context) => {
return Type.atom("Elixir.String.Chars");
}}]);

Interpreter.defineElixirFunction("String.Chars.Time", "to_string", 1, "public", [{params: (context) => [Type.variablePattern("time_0")], guards: [], body: (context) => {
Interpreter.matchOperator(context.vars.time_0, Type.map([[Type.atom("calendar"), Type.variablePattern("calendar_5")], [Type.atom("hour"), Type.variablePattern("hour_1")], [Type.atom("microsecond"), Type.variablePattern("microsecond_4")], [Type.atom("minute"), Type.variablePattern("minute_2")], [Type.atom("second"), Type.variablePattern("second_3")]]), context);
Interpreter.updateVarsToMatchedValues(context);
return Interpreter.callNamedFunction(context.vars.calendar_5, Type.atom("time_to_string"), Type.list([context.vars.hour_1, context.vars.minute_2, context.vars.second_3, context.vars.microsecond_4]), context);
}}]);

Interpreter.defineElixirFunction("Time", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Time")], [Type.atom("calendar"), Type.atom("Elixir.Calendar.ISO")], [Type.atom("hour"), Type.atom("nil")], [Type.atom("microsecond"), Type.tuple([Type.integer(0n), Type.integer(0n)])], [Type.atom("minute"), Type.atom("nil")], [Type.atom("second"), Type.atom("nil")]]);
}}]);

Interpreter.defineElixirFunction("Time", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
Interpreter.matchOperator(Elixir_Enum["reduce/3"](context.vars.kv_0, Type.tuple([Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Time")], [Type.atom("calendar"), Type.atom("Elixir.Calendar.ISO")], [Type.atom("hour"), Type.atom("nil")], [Type.atom("microsecond"), Type.tuple([Type.integer(0n), Type.integer(0n)])], [Type.atom("minute"), Type.atom("nil")], [Type.atom("second"), Type.atom("nil")]]), Type.list([Type.atom("hour"), Type.atom("minute"), Type.atom("second")])]), Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.tuple([Type.variablePattern("map_3"), Type.variablePattern("keys_4")])], guards: [], body: (context) => {
return Type.tuple([Elixir_Map["merge/2"](context.vars.map_3, Type.map([[context.vars.key_1, context.vars.val_2]])), Elixir_List["delete/2"](context.vars.keys_4, context.vars.key_1)]);
}}], context, "-__struct__/1-fun-0-")), Type.tuple([Type.variablePattern("map_5"), Type.variablePattern("keys_6")]), context);
Interpreter.updateVarsToMatchedValues(context);
return Interpreter.case(context.vars.keys_6, [{match: Type.list([]), guards: [], body: (context) => {
return context.vars.map_5;
}}, {match: Type.matchPlaceholder(), guards: [], body: (context) => {
return Erlang["error/1"](Elixir_ArgumentError["exception/1"](Type.bitstring([Type.bitstringSegment(Type.string("the following keys must also be given when building "), {type: "binary"}), Type.bitstringSegment(Type.string("struct "), {type: "binary"}), Type.bitstringSegment(Elixir_Kernel["inspect/1"](Type.atom("Elixir.Time")), {type: "binary"}), Type.bitstringSegment(Type.string(": "), {type: "binary"}), Type.bitstringSegment(Elixir_Kernel["inspect/1"](context.vars.keys_6), {type: "binary"})])));
}}], context);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));